AllWaysPayWinAnimator = {};
AllWaysPayWinAnimator.animationPool = [];
AllWaysPayWinAnimator.currentAnimations = [];
AllWaysPayWinAnimator.winBoxYTweak = 0;
AllWaysPayWinAnimator.symbolwinOffsetX = 0;
AllWaysPayWinAnimator.symbolwinOffsetY = -0;
AllWaysPayWinAnimator.gameReels = undefined;

AllWaysPayWinAnimator.offsetY = -10;

AllWaysPayWinAnimator.ready = false;

AllWaysPayWinAnimator.initialise = function () {
  AllWaysPayWinAnimator.animationPool = [
    {
      poolName: "Jack",
      number: 0,
      pool: [],
    },
    {
      poolName: "Queen",
      number: 0,
      pool: [],
    },
    {
      poolName: "King",
      number: 0,
      pool: [],
    },
    {
      poolName: "Ace",
      number: 0,
      pool: [],
    },
    {
      poolName: "Horseshoe",
      number: 0,
      pool: [],
    },
    {
      poolName: "Hat",
      number: 0,
      pool: [],
    },
    {
      poolName: "Pot",
      number: 0,
      pool: [],
    },
    {
      poolName: "Logo",
      number: 0,
      pool: [],
    },
    {
      poolName: "Wild",
      number: 0,
      pool: [],
    },
    {
      poolName: "Bonus",
      number: 0,
      pool: [],
    },
    {
      poolName: "symbolWin",
      number: 0,
      pool: [],
    },
  ];

  for (let i = 0; i < 3; i++) {
    AllWaysPayWinAnimator.createAnim("Jack", i);
    AllWaysPayWinAnimator.createAnim("Queen", i);
    AllWaysPayWinAnimator.createAnim("King", i);
    AllWaysPayWinAnimator.createAnim("Ace", i);
    AllWaysPayWinAnimator.createAnim("Horseshoe", i);
    AllWaysPayWinAnimator.createAnim("Hat", i);
    AllWaysPayWinAnimator.createAnim("Pot", i);
    AllWaysPayWinAnimator.createAnim("Logo", i);
    AllWaysPayWinAnimator.createAnim("Wild", i);
    AllWaysPayWinAnimator.createAnim("Bonus", i);
    AllWaysPayWinAnimator.createAnim("symbolWin", i);
  }

  AllWaysPayWinAnimator.gameReels = gameData.reels;

  AllWaysPayWinAnimator.ready = true;

  messageBus.subscribe("spinner:SpinEvent", AllWaysPayWinAnimator.doSpin);
  messageBus.subscribe("spinner:ReSpinEvent", AllWaysPayWinAnimator.doSpin);
};

AllWaysPayWinAnimator.doSpin = function (spinTask) {
  AllWaysPayWinAnimator.reels = spinTask.data.resultPanel.reelList;
};

AllWaysPayWinAnimator.createAnim = function (
  name,
  index,
  poolIndex = undefined
) {
  let anim = undefined;

  if (name === "symbolWin") {
    anim = resourceManager.createObject(
      "movie",
      name + "_" + index,
      "slotContainer:symbolWinBorderAnim",
      {
        definition: name,
        anchor: 0.5,
        scale: 1.8,
      }
    );
  } else {
    anim = resourceManager.createObject(
      "movie",
      name + "_" + index,
      "slotContainer:reelContainer:foregroundReelSymbols",
      {
        definition: name,
        anchor: 0.5,
      }
    );
  }

  anim.loop = false;
  anim.gotoAndStop(0);
  anim.visible = false;

  if (poolIndex === undefined) {
    for (let i = 0; i < AllWaysPayWinAnimator.animationPool.length; i++) {
      let poolType = AllWaysPayWinAnimator.animationPool[i];

      if (poolType.poolName === name) {
        poolType.pool.push(anim);
        poolType.number++;
      }
    }
  } else {
    AllWaysPayWinAnimator.animationPool[poolIndex].pool.push(anim);
    AllWaysPayWinAnimator.animationPool[poolIndex].number++;
  }

  return anim;
};

AllWaysPayWinAnimator.positionAnim = function (animationObject) {
  const reels = AllWaysPayWinAnimator.gameReels;
  const anim = animationObject.anim;
  const reel = animationObject.reel;
  const row = animationObject.row;

  const x = reels[reel].position.getX() - 12;
  const y =
    reels[reel].position.getY() + row * reels[reel].Props.appertureSpacing - 10;

  anim.position.set(x, y);
};

AllWaysPayWinAnimator.animatePotsOnly = function (
  data,
  callback,
  singleWinCallback,
  delay = 0,
  winBorderOnly = false
) {
  AllWaysPayWinAnimator.animate(
    data,
    callback,
    singleWinCallback,
    delay,
    winBorderOnly,
    true
  );
};

AllWaysPayWinAnimator.animate = function (
  data,
  callback,
  singleWinCallback,
  delay = 0,
  winBorderOnly = false,
  animatePotsOnly = false
) {
  AllWaysPayWinAnimator.wins = [];
  AllWaysPayWinAnimator.highestSymbol = 0;

  const POT_SYMBOL_ID = resourceManager.getConfiguration().symbols["Pot"].ID;
  const wins = data.winningLineEvent.winningLines;

  const uniqueWinningSymbolsSet = new Set();
  wins.forEach(function (win) {
    const winSymbol = win.symbol.value;

    let shouldInclude = false;
    if (animatePotsOnly && winSymbol === POT_SYMBOL_ID) {
      shouldInclude = true;
    } else if (!animatePotsOnly) {
      shouldInclude = true;
    }

    if (shouldInclude) {
      if (winSymbol > AllWaysPayWinAnimator.highestSymbol) {
        AllWaysPayWinAnimator.highestSymbol = winSymbol;
      }
      win.winSymPositions.forEach(function (symbol) {
        uniqueWinningSymbolsSet.add(JSON.stringify(symbol));
      });
    }
  });

  AllWaysPayWinAnimator.wins = Array.from(uniqueWinningSymbolsSet).map((symbol) => {
    return JSON.parse(symbol);
  });

  timerManager.addTimeout(delay, () => {
    for (var i = 0; i < reelManager.reels.length; i++) {
      reelManager.reels[i].dimAllSymbols(true, 0x666666);
    }

    AllWaysPayWinAnimator.singleWinCallback = singleWinCallback;

    AllWaysPayWinAnimator.finishedCallback = callback;

    AllWaysPayWinAnimator.animateNextWin(winBorderOnly);
  });
};

AllWaysPayWinAnimator.highlightWithBorderOnly = function (reel, row) {
  const symbolWinAnim = AllWaysPayWinAnimator.findAnimation("symbolWin");

  const symbolWinObject = {
    anim: symbolWinAnim,
    reel: reel,
    row: row,
  };

  AllWaysPayWinAnimator.currentAnimations.push(symbolWinObject);

  symbolWinAnim.onComplete = function () {
    AllWaysPayWinAnimator.animationFinished(symbolWinObject);
    AllWaysPayWinAnimator.returnToPool("symbolWin", symbolWinAnim);
  };
  symbolWinAnim.onFrameChange = function () {
    if (gameController.hasSkippedWin()) {
      symbolWinAnim?.onComplete();
    }
  };

  AllWaysPayWinAnimator.positionAnim(symbolWinObject);

  if (gameController.hasSkippedWin()) {
    symbolWinAnim.onComplete?.();
    return;
  }

  symbolWinAnim.visible = true;
  symbolWinAnim.gotoAndPlay(0);
};

AllWaysPayWinAnimator.animateSymbolWithoutBorder = function (
  symMovieName,
  reel,
  row
) {
  let animation = AllWaysPayWinAnimator.findAnimation(symMovieName);

  let animationObject = {
    anim: animation,
    reel: reel,
    row: row,
  };

  AllWaysPayWinAnimator.currentAnimations.push(animationObject);

  const callback = () => {
    AllWaysPayWinAnimator.animationFinished(animationObject);
    AllWaysPayWinAnimator.returnToPool(symMovieName, animation);

    const bonusID = resourceManager.getConfiguration().symbols["Bonus"].ID;
    for (var i = 0; i < reelManager.reels.length; i++) {
      for (var j = 0; j < 3; j++) {
        if (reelManager.reels[i].symbolData[j].symbolId === bonusID) {
          gameData.reels[i].showSymbol(j, true);
        }
      }
    }
  };

  AllWaysPayWinAnimator.positionAnim(animationObject);

  animation.visible = true;
  animation.gotoAndPlay(0);

  return callback;
};

AllWaysPayWinAnimator.animateSymbol = function (symMovieName, reel, row) {
  if (gameController.hasSkippedWin()) return;

  let animation = AllWaysPayWinAnimator.findAnimation(symMovieName);
  let symbolWinAnim = AllWaysPayWinAnimator.findAnimation("symbolWin");

  let animationObject = {
    anim: animation,
    reel: reel,
    row: row,
  };

  let symbolWinObject = {
    anim: symbolWinAnim,
    reel: reel,
    row: row,
  };

  AllWaysPayWinAnimator.currentAnimations.push(animationObject);
  AllWaysPayWinAnimator.currentAnimations.push(symbolWinObject);

  symbolWinAnim.onComplete = function () {
    AllWaysPayWinAnimator.animationFinished(symbolWinObject);
    AllWaysPayWinAnimator.returnToPool("symbolWin", symbolWinAnim);
  };
  symbolWinAnim.onFrameChange = function () {
    if (gameController.hasSkippedWin()) {
      symbolWinAnim?.onComplete();
    }
  }


  AllWaysPayWinAnimator.positionAnim(animationObject);
  AllWaysPayWinAnimator.positionAnim(symbolWinObject);

  if (gameController.canCelebrate || freespins.inFreespins) {
    gameData.reels[reel].showSymbol(row, false);

    if (symMovieName === "Pot") {
      // move cashPotOverlay so that it can be seen on top of symbol anim
      const cashPotOverlay = gameData.reels[reel].getCashPotOverlay(row);
      const cashPotOverlayParent = cashPotOverlay.parent;

      animationObject.originalCashPotOverlayIndex =
        cashPotOverlayParent.getChildIndex(cashPotOverlay);
      cashPotOverlay.position = animation.toLocal(
        cashPotOverlay.toGlobal(systemData.stage)
      );
      animation.addChild(cashPotOverlay);

      // when anim complete, can move back to original place (child of static symbol)
      animation.hasCompleted = false;
      animation.onComplete = function () {
        if (
          !animation.hasCompleted &&
          animationObject?.originalCashPotOverlayIndex != null
        ) {
          cashPotOverlayParent.addChildAt(
            cashPotOverlay,
            animationObject.originalCashPotOverlayIndex
          );
          cashPotOverlay.position = { x: 0, y: 0 };
          cashPotOverlay.cashPotData = null;
          animation.hasCompleted = true;
          gameData.reels[reel].showSymbol(row, true);
          AllWaysPayWinAnimator.animationFinished(animationObject);
          AllWaysPayWinAnimator.returnToPool(symMovieName, animation);
        }
      };
    } else {
      animation.onComplete = function () {
        gameData.reels[reel].showSymbol(row, true);
        AllWaysPayWinAnimator.animationFinished(animationObject);
        AllWaysPayWinAnimator.returnToPool(symMovieName, animation);
      };
    }

    animation.onFrameChange = function () {
      if (gameController.hasSkippedWin()) {
        if (animation.hasCompleted != null) {
          animation.hasCompleted = true;
        }
        animation?.onComplete();
      }
    };

    if (gameController.hasSkippedWin()) {
      if (animation.hasCompleted != null) {
        animation.hasCompleted = true;
      }
      animation.onComplete?.();
      symbolWinAnim.onComplete?.();
      return;
    }
    animation.visible = true;
    animation.gotoAndPlay(0);
  }

  symbolWinAnim.visible = true;
  symbolWinAnim.gotoAndPlay(0);
};

AllWaysPayWinAnimator.findAnimation = function (symMovieName) {
  let animation = undefined;
  let location = 0;
  let number = 0;

  for (let i = 0; i < AllWaysPayWinAnimator.animationPool.length; i++) {
    let poolType = AllWaysPayWinAnimator.animationPool[i];

    if (poolType.poolName === symMovieName) {
      number = poolType.number;
      location = i;

      if (poolType.pool.length > 0) {
        animation = poolType.pool.shift();
        return animation;
      }
    }
  }

  animation = AllWaysPayWinAnimator.createAnim(symMovieName, number + 1);
  AllWaysPayWinAnimator.animationPool[location].pool.pop();
  return animation;
};

AllWaysPayWinAnimator.returnToPool = function (name, animation) {
  for (let i = 0; i < AllWaysPayWinAnimator.animationPool.length; i++) {
    let poolType = AllWaysPayWinAnimator.animationPool[i];

    if (poolType.poolName === name) {
      const alreadyInPool = poolType.pool.filter((anim) => anim.name === animation.name).length > 0;
      if (!alreadyInPool) {
        poolType.pool.push(animation);
      }
    }
  }
};

AllWaysPayWinAnimator.animateNextWin = function (winBorderOnly = false) {
  if (gameController.hasSkippedWin()) {
    AllWaysPayWinAnimator.skip();
    return;
  }
  const symbolInfo = resourceManager.getConfiguration().symbols;
  const symInfoId = Object.keys(symbolInfo).find(function (key) {
    return AllWaysPayWinAnimator.highestSymbol === symbolInfo[key].ID;
  });

  if (AllWaysPayWinAnimator.currentAnimations.length > 0) {
    AllWaysPayWinAnimator.skip();
  }

  // if winBorderOnly, then win <= stake (see where showWinSymbolAnimationsAndCountUp is assigned in gameController.doPayWins())
  if (winBorderOnly) {
    soundManager.play("reelWinLTS");
  } else {
    soundManager.play("reelWin");
  }

  AllWaysPayWinAnimator.currentAnimations = [];
  AllWaysPayWinAnimator.wins.forEach(function (symbol) {
    if (gameController.hasSkippedWin()) return;
    let symbolName = Object.keys(resourceManager.getConfiguration().symbols)[
      symbol.sym
    ];

    reelManager.reels[symbol.reel].dimSymbol(symbol.row, false);

    if (winBorderOnly) {
      AllWaysPayWinAnimator.highlightWithBorderOnly(symbol.reel, symbol.row);
    } else {
      AllWaysPayWinAnimator.animateSymbol(symbolName, symbol.reel, symbol.row);
    }
  });
};

AllWaysPayWinAnimator.animationFinished = function (animationObject) {
  if (animationObject !== undefined) {
    animationObject.anim.gotoAndStop(0);
    animationObject.anim.visible = false;
    AllWaysPayWinAnimator.currentAnimations.splice(
      AllWaysPayWinAnimator.currentAnimations.indexOf(animationObject),
      1
    );
  }

  if (AllWaysPayWinAnimator.currentAnimations.length === 0) {
    if (AllWaysPayWinAnimator.finishedCallback) {
      AllWaysPayWinAnimator.finishedCallback();
    }
  }

  if (AllWaysPayWinAnimator.singleWinCallback) {
    AllWaysPayWinAnimator.singleWinCallback();
  }

  for (var i = 0; i < reelManager.reels.length; i++) {
    reelManager.reels[i].dimAllSymbols(false, 0x666666);
  }
};

AllWaysPayWinAnimator.skip = function () {
  AllWaysPayWinAnimator.currentAnimations.forEach((animation) => {
    animation.anim?.onComplete?.();
    animation.anim.gotoAndStop(0);
    animation.anim.visible = false;
  });

  for (var i = 0; i < reelManager.reels.length; i++) {
    reelManager.reels[i].dimAllSymbols(false, 0x666666);
  }

  for (var i = 0; i < reelManager.reels.length; i++) {
    for (var j = 0; j < 3; j++) {
      gameData.reels[i].showSymbol(j, true);
    }
  }

  AllWaysPayWinAnimator.currentAnimations = [];

  if (AllWaysPayWinAnimator.finishedCallback) {
    AllWaysPayWinAnimator.finishedCallback();
  }

  if (AllWaysPayWinAnimator.singleWinCallback) {
    AllWaysPayWinAnimator.singleWinCallback();
  }
};

AllWaysPayWinAnimator.onOrientationChange = function () {
  if (AllWaysPayWinAnimator.ready) {
    AllWaysPayWinAnimator.currentAnimations.forEach((animationObject) => {
      AllWaysPayWinAnimator.positionAnim(animationObject);
    });
  }
};

AllWaysPayWinAnimator.onReady = function () {
  // AllWaysPayWinAnimator.ready = true;
};

Reflex.registerEventHandler(
  "layoutChange",
  AllWaysPayWinAnimator.onOrientationChange
);
Reflex.registerEventHandler("ready", AllWaysPayWinAnimator.onReady);
